import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CalendarRange } from "lucide-react";
import { api, errMsg } from "../lib/api";

export default function Schedule90Button({ onDone, testId = "schedule-90-btn" }) {
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const run = async () => {
    if (!window.confirm("Schedule the next 90 days? Week 1 is re-planned (completed batches are kept), then days 8–90 are planned from inventory demand and active Production Plans.")) return;
    setBusy(true);
    try {
      const r = (await api.post("/schedule/horizon/generate")).data;
      toast.success(`Next 90 days scheduled${r.backlog.length ? ` · ${r.backlog.length} over capacity` : ""}`, { action: { label: "View 90-Day", onClick: () => nav("/schedule/90") } });
      onDone?.(r);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <button data-testid={testId} disabled={busy} onClick={run}
      className="h-12 px-5 rounded-md border-2 border-[#F59E0B] text-[#F59E0B] font-bold flex items-center gap-2 hover:bg-[#F59E0B]/10 disabled:opacity-40">
      <CalendarRange className="w-4 h-4" />{busy ? "Scheduling…" : "Schedule Next 90 Days"}
    </button>
  );
}
